/*** IMPORTS FROM imports-loader ***/
var lib = require("whatwg-fetch");

null

/*** EXPORTS FROM exports-loader ***/
module.exports = lib.Request;



//////////////////
// WEBPACK FOOTER
// ./~/imports-loader?lib=whatwg-fetch!./~/exports-loader?lib.Request!
// module id = 10
// module chunks = 0